module.exports = __webpack_public_path__ + "static/media/abstract_thumb.ebd2e870.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/abstract_thumb.jpg
// module id = 310
// module chunks = 0